<template>
  <div>
    <div class="standart-page">
      <div class="row">
        <div class="col"></div>
        <div class="col"><h3 class="title">ISBN</h3></div>
        <div class="col d-flex justify-content-end align-items-start"></div>
      </div>
      <div class="card-component mb-5">
        <div class="body">
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                  <label>ISBN Numarası</label>
                  <input type="text" class="form-control" v-model="form.isbn" maxlength="64">
              </div>
            </div>
            <div class="col-sm-3" v-if="$store.state.auth.user.mbId === 0">
                <div class="form-group">
                  <label>Meslek Birliği</label>
                  <select v-select
                      class="form-control"
                      v-model="form.mbId">
                    <option :value="0" v-if="mblist.length > 1">Seçiniz</option>
                    <option :value="item.id"
                        v-for="(item,index) in mblist"
                        :key="index">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
            </div>
          </div>
        </div>
        <div class="footer d-flex justify-content-end">
          <button class="btn btn-outline-secondary mt-4" @click="clear">Temizle</button>
          <button class="btn btn-secondary mt-4" @click="search">Listele</button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th class="fit">ISBN Numarası</th>
              <th>Eser Adı</th>
              <th class="fit" v-if="$store.state.auth.user.mbId === 0">Meslek Birliği</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in $store.state.isbn.isbn.liste" :key="index" :class="{ 'danger': item.kayitDurumu != 1 }" class="cursor-pointer" @click="$router.push('/isbn-kutuphanesi/detay/' + item.searchISBNNumarasi)">
              <td class="fit">{{ item.isbnNumarasi }}</td>
              <td>{{ item.adi }}</td>
              <td class="fit" v-if="$store.state.auth.user.mbId === 0">{{ item.mbName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
      <div class="row" v-if="$store.state.isbn.isbn.liste.length > 0">
        <div class="col">
          <i class="text-secondary">{{ $store.state.isbn.isbn.sayfalama.totalItems }} kayıttan {{ ((form.pageNum - 1) * form.pageSize) + 1 }} - {{ form.pageNum * form.pageSize }} arası gösterilmektedir</i>
        </div>
        <div class="col">
          <div class="row">
            <div class="col d-flex justify-content-end">
              <nav>
                <paginate v-if="$store.state.isbn.isbn.liste.length"
                          :page-count="$store.state.isbn.isbn.sayfalama.totalPages"
                          :click-handler="changePage"
                          :prev-text="'Önceki'"
                          :next-text="'Sonraki'"
                          :active-class="'active'"
                          :container-class="'pagination'"
                          v-model="form.pageNum">
                </paginate>
              </nav>
            </div>
            <div class="col-2">
              <select v-select class="form-control" v-model="form.pageSize" @change="changeSize">
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data() {
    return {
      prevRoute:null,
      errorMessage:'',
      showError: false,
      mblist:[],
      overlay: false,
      form: {
        mbId:this.$store.state.auth.user.mbId,
        isbn:"",
        pageNum: 1,
        pageSize: 25
      }
    }
  },
  methods: {
    ...mapActions("general", ["showModal", "errorHandling", "fileUpload"]),
    ...mapActions('uye', ['getMBList']),
    ...mapActions('isbn', ['searchISBN']),
    clear() {
      this.$store.state.isbn.searchList = false;
      this.$store.state.isbn.isbn = Object.assign({}, {
        liste: [],
        sayfalama: {}
      });
      this.form = Object.assign({}, {
        pageNum: 1,
        pageSize: 25,
        mbId:this.$store.state.auth.user.mbId,
        isbn:""
      });
      this.$store.state.isbn.duplicateForm = Object.assign({}, this.form);
      this.showError = false;
    },
    changeSize() {
      this.list();
    },
    changePage(pageNumber) {
      this.form.pageNum = pageNumber;
      this.list();
    },
    search(){
      this.form.pageNum = 1;
      this.list();
    },
    list() {
      this.$store.state.isbn.isbn.liste = [];
      if (this.isEmptyFilterForm()) {
        this.showError = true;
        this.errorMessage = this.getMessage(140);
        return;
      }

      this.$store.state.isbn.duplicateForm = Object.assign({}, this.form);
      this.$store.state.general.showOverlay = true;
      this.showError = false;
      
      this.searchISBN(this.form).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
          this.$store.state.isbn.searchList = true;
        }else{
          this.$store.state.isbn.searchList = true;
          this.showError = false;
          this.errorMessage = "";
          this.$store.state.isbn.isbn.liste.forEach(element => {
            let mbCheck = this.mblist.filter(x => x.id === element.mbId);
            if(mbCheck.length > 0)
              element.mbName = mbCheck[0].name;
          });
        }
      }).catch(() => {
        this.$store.state.general.showOverlay = false;
      });
    },
    getMBListOptions(){
        if(this.$store.state.auth.user.mbId !== 0)
          return;

        this.$store.state.general.showOverlay = true;
        this.getMBList().then(res => {
          if(res.errorCode == 0){
            this.mblist = res.data;
          }else{
            this.errorHandling(res);
          }
          this.$store.state.general.showOverlay = false;
        });
    },
    isEmptyFilterForm() {
      this.formTrimCheck(this.form);
      return this.form.isbn === "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created() {
      this.getMBListOptions();
  },
  watch: {
    prevRoute(nw) {
      if (nw.name === 'isbn-kutuphanesi-detay' || nw.name === 'isbn-kutuphanesi-detay-id') {
        if (Object.keys(this.$store.state.isbn.duplicateForm).length > 0) {
          this.form = Object.assign({}, this.$store.state.isbn.duplicateForm);
          if(this.$store.state.isbn.searchList){
            this.list();
          }
        }
        this.list();
      } else {
        this.clear();
      }
    }
  },
  computed: {
    ...mapGetters('general', ['getMessage', 'getOptionWithParams', 'formTrimCheck'])
  }
};
</script>